<template>
  <div>

  </div>
</template>

<script>
  export default {
    name: 'RegistrLayout'
  }
</script>

<style lang="scss" scoped>

</style>